/**
 * LLM切り替えスイッチ
 *
 * REACT_APP_LLM_PROVIDER=appsync (デフォルト) → AppSync → Lambda → Bedrock（推奨）
 * REACT_APP_LLM_PROVIDER=openai  → OpenAI API（デバッグ用）
 */
import { callAppSync } from "./appsync";
import { callOpenAI } from "./openai";

const provider = process.env.REACT_APP_LLM_PROVIDER || "appsync";

/**
 * LLM を呼び出す統一インターフェース
 * @param {Array<{role: string, content: string}>} messages
 * @returns {Promise<string>}
 */
export const callLLM = async (messages) => {
  switch (provider) {
    case "openai":
      return callOpenAI(messages);
    case "appsync":
    default:
      return callAppSync(messages);
  }
};
